'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".ThemedHistory-module_listItem__nryaY{margin:.75rem 0 0}";
var styles = {"listItem":"ThemedHistory-module_listItem__nryaY"};
styleInject["default"](css_248z, '3c369e25-a51e-4da8-a4b6-6b6d5b802ed7');

exports["default"] = styles;
